import { lexonHttp as http } from '@/plugins/axios/lexonHttp'
import { createJsonRequest } from '@/helpers/http'

export class ProfessionalsService {
  getData(url: string) {
    return http.get(url)
  }

  deleteData(url: string) {
    return http.delete(url)
  }

  async read(): Promise<any> {
    return await http.get('/v2/professional')
  }

  async factura_e_active(): Promise<any> {
    return await http.get('/v2/professional/factura-e-active')
  }

  async create(data: object): Promise<any> {
    const params = createJsonRequest(data)
    return await http.post('/v2/professional', params, { validateStatus: (_status) => true })
  }

  async update(data: object): Promise<any> {
    const { id } = data as { id: string }
    const params = createJsonRequest(data)
    return await http.put(`/v2/professional/${id}`, params, { validateStatus: (_status) => true })
  }

  async remove(id: string): Promise<any> {
    return await http.delete(`/v2/professional/${id}`, { validateStatus: (_status) => true })
  }
}
